module.exports = __webpack_public_path__ + "assets/img/mujun_cover.5fd44193.png";